export const SDK_VERSION = '6.19.1';
